export const VALIDATION_CODES = {
  DATE: 'questionnaire.questions.errors.date',
  EMAIL: 'questionnaire.questions.errors.email',
  UINT: 'questionnaire.questions.errors.uint',
  EMAILS_LIST: 'questionnaire.questions.errors.emails_list',
  REQUIRED: 'questionnaire.questions.errors.required',
};
